// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewLab_container__iMb5s"};